<template>
   <div class="page-user-lsit">
      <div class="pg-breadcrumb">
         <div class="breadcrumb-item em">後臺管理</div>
         <div class="breadcrumb-item">追加费用</div>
      </div>

      <div class="card-block pd-bt">
         <Spin fix class="pg-sub-loading" v-if="isSubmiting">
            <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
            <div class="loading-text">Loading</div>
         </Spin>
         <div class="pg-toolbar">
            <div class="pg-btn-wrap">
               <div class="pg-btn style1" @click="handleToAdd(0)">新增</div>
            </div>
         </div>
         <Table size="small"
                no-data-text="暫無數據"
                border
                maxHeight="680"
                :columns="table.column"
                :data="table.data">
            <template slot-scope="{ row, index }" slot="action">
               <div class="pg-btn-wrap">
                  <div class="pg-btn style2" @click="handleEditModal(row)">修改费用</div>
                  <!--<div class="pg-btn style1" @click="handleDelete(row)">删除</div>-->
               </div>
            </template>
         </Table>
      </div>
      <Modal
         v-model="showModal"
         title="追加费用"
         @on-ok="ok">
         <Row>
            <Col span="24" push="5">
               <Form :label-width="150">
                  <Row :gutter="15">
                     <Col span="14">
                        <FormItem>
                           <div slot="label" class="form-label">
                              <em class="red">* </em>
                              <span>费用名称</span>
                           </div>

                           <Input v-model="form.name" style="width:100%" clearable/>
                        </FormItem>
                     </Col>
                  </Row>

               </Form>
            </Col>
         </Row>

      </Modal>
   </div>
</template>

<script>

export default {
   data() {
      return {
         srcList: [],
         isSubmiting: false,
         status: false, // 是否開啓
         showModal: false,
         editAddType: 0,
         table: {
            column: [
               {
                  title: '排序',
                  key: 'index',
                  align: 'center',
                  minWidth: 80
               },
               {
                  title: '费用名称',
                  key: 'name',
                  align: 'center',
                  minWidth: 80
               },
               {
                  title: '操作',
                  slot: 'action',
                  align: 'center',
                  minWidth: 150
               },
            ],
            data: []
         },
         form: {
            id: '',
            name: '',
         },
      };
   },
   activated() {

   },
   created() {
      this.getList();
   },
   methods: {

      // 新增   appRecommendedAdd 修改 appRecommendedSet
      ok() {
         let url, form = this.form;
         this.editAddType === 0 ? (url = this.$Api.addFees,delete form.id) : (url = this.$Api.updateFees)
         this.$Rq.requestAuth({
            url,
            method: 'post',
            data: form
         }).then((res) => {
            this.$Utils.showSuccess(res.msg);
            if (res.code === 0) {
               this.removeForm();
               this.getList();
            }
         })
      },

      // 列表
      getList() {
         this.isSubmiting = true;
         this.$Rq.requestAuth({
            url: this.$Api.listFees,
            method: 'get',
            data: {limit: 1000}
         }).then((res) => {
            this.isSubmiting = false;
            if (res.code == 0) {
               this.table.data = res.data.data.map((item,index) => {
                  item.index = index + 1
                  return item
               })
            } else {
               this.showTipInfo(res.msg);
            }
         }).catch((err) => {
            this.isSubmiting = false;
         });
      },

      // 删除
      handleDelete(item) {
         let id = item.id;
         this.$Modal.confirm({
            title: '提示',
            content: '確定刪除嗎？',
            cancelText: '取消',
            okText: '確定',
            onOk: () => {
               this.isSubmiting = true;
               this.$Rq.requestAuth({
                  url: this.$Api.appRecommendedMdel,
                  method: 'post',
                  data: {id}
               }).then((res) => {
                  this.isSubmiting = false;
                  this.$Utils.showSuccess(res.msg);
                  if (res.code == 0) {
                     this.getList();
                  }
               }).catch((err) => {
                  this.isSubmiting = false;
                  this.$Utils.showSuccess('网络异常');
               });
            }
         });
      },

      // 弹出 修改
      handleEditModal(row) {
         this.form = {
            id: row.id,
            name: row.name
         }
         this.handleToAdd(1)
      },

      // 弹出新增
      handleToAdd(type) {
         // this.$router.push({path: '/recommendedAdd'});
         type === 0 && this.removeForm();
         this.editAddType = type
         this.showModal = true;
      },

      // 清空form
      removeForm() {
         this.form.name = ''
      },
   }
};
</script>

<style lang="scss" scoped>
@import 'customFees.scss';
</style>
